const FORM = (() => {
  // make a form component that takes care of everything
  // create event listener on form no for handeling data
})();
